import { useTranslation } from "react-i18next";
import GoogleAutocompleteWrapper from "../../../util/component/GoogleAutocompleteWrapper";
import { CBGoogleAutocompleteType } from "../types";
import { SyntheticEvent, useEffect, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { googleSearchBarClearValueState } from "../state/customerbaseState";

interface CBGoogleAutocompleteSearchBarProps {
    idField: string,
    onPlaceSelected: (place: any) => void,
    onChange: (event: any) => void
}

const CBGoogleAutocompleteSearchBar = ({
    idField,
    onPlaceSelected,
    onChange
} : CBGoogleAutocompleteSearchBarProps) => {

    const { t } = useTranslation('customerbase');
    const [value, setValue] = useState('');

    const clearValueState = useRecoilValue(googleSearchBarClearValueState);
    const setClearValueState = useSetRecoilState(googleSearchBarClearValueState);

    useEffect(() => {
        if(clearValueState) {
            setValue('');
            setClearValueState(false);
        }
            
    }, [clearValueState]);

    return (
        <GoogleAutocompleteWrapper
            googleInputProps={{
                options: {
                    types: [CBGoogleAutocompleteType.ADDRESSES],
                    fields: ['address_components']
                },
                onPlaceSelected: (place) => {
                    onPlaceSelected(place);
                    setValue('');
                } 
            }}
            inputProps={{
                fullWidth: true,
                id: idField,
                name: idField,
                type: 'text',
                label: t("googleAutocompleteLabel"),
                onChange: (event) => {
                    setValue(event.currentTarget.value);
                    onChange(event);

                },
                value: value
                
            }} 
        
        />

    );

}

export default CBGoogleAutocompleteSearchBar;